import Header from "./Header";
import Image from "react-bootstrap/Image";
import "./Solution.css";
import img1 from './services/1.jpeg';
import img2 from './services/2.jpeg';
import img3 from './services/3.jpeg';
import img4 from './services/4.jpeg';
import img5 from './services/5.jpeg';
import img6 from './services/6.jpeg';
import img7 from './services/7.jpeg';
import img8 from './services/8.jpeg';
import img9 from './services/9.jpeg';
import Footer from "./Footer";


function Solution(){
 return (
   <div>
    <Header />
   
    <div className="container-fluid our-mission">
    <h1>Services</h1>
    <h2 className="heading-text">Transmission Line </h2>
    <div className="row">

        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 image-class"><Image src={img1} fluid thumbnail className="thumb-image"/></div>
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-justify"> “LEVINA” Power Transmission business vertical is a powerful player that offers integrated solutions and end-to-end services ranging from construction to commissioning in the field of overhead high voltage transmission lines, substations projects and project electrification. We take continue action for operation & maintenance of transmission assets to ensure compliances with prescribed standard as well as to achieve high quality.
POWERGRID, a transmission licensee, takes continuous action for operation and m
“LEVINA”is leadings EPC player in the field of power transmission and solar energy. The business has set benchmarks in capacity, complexity and speed of execution and through their dedicated business segments offers integrated solutions for a broad spectrum of power transmission.
</div>
</div>

</div>
<div className="container-fluid">
    <h2 className="heading-text"> Substation Switchyards</h2>
    <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-justify"><p className=""> Our substation crews to stay abreast of evolving technologies and we have a proven quality control/quality assurance program that is integral to all of our substation projects.
Our crews are provided with the most advanced tools and equipment available, have access to tools, and work procedures that enable us to perform many substation/switchyard maintenance and erection procedures. We offer complete testing and commissioning.
</p></div>
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 image-class"><Image src={img2} fluid thumbnail className="thumb-image"/></div>
    </div>
</div>
<div className="container-fluid our-mission">
 
    <h2 className="heading-text">Solar Power </h2>
    <div className="row">

        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 image-class"><Image src={img3} fluid thumbnail className="thumb-image"/></div>
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-justify"> “LEVINA"is specializing in high efficiency engineering, procurement and construction services, operations, and maintenance of solar power plants.
</div>
</div>

</div>
<div className="container-fluid">
    <h2 className="heading-text"> Building Construction </h2>
    <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-justify"><p className=""> “LEVINA” is a business vertical that is equipped with the domain knowledge, requisite expertise and wide-ranging experience to undertake Engineering, Procurement and Construction (EPC) of all types of building and factory structures through its dedicated Business Units.

“LEVINA” provides concept to commissioning solutions for IT parks, office spaces including high-rise towers and green buildings.
</p></div>
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 image-class"><Image src={img4}  fluid thumbnail className="thumb-image"/></div>
    </div>
</div>
<div className="container-fluid our-mission">
 
    <h2 className="heading-text">Rural Electrification</h2>
    <div className="row">

        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 image-class"><Image src={img5} fluid thumbnail className="thumb-image"/></div>
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-justify"> “LEVINA” is primarily engaged in providing for rural electrification projects across India. 
</div>
</div>

</div>
<div className="container-fluid">
    <h2 className="heading-text"> Revetment </h2>
    <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-justify"><p className=""> Waterway expansion necessarily involves securing beds and embankments against erosion from waves, currents, wind and alternating water levels.
For this purpose, we create erosion-proof, scattered and set stone revetments, over a geotextile or mineral filter; these are made of natural stone and concrete, plus, where necessary, revetment panels and matting.
As an alternative to stone fill and sheet piling, we also increasingly apply technical/biological methods of securing banks, which are preferable from an ecological point of view.

</p></div>
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 image-class"><Image src={img6} fluid thumbnail className="thumb-image"/></div>
    </div>
</div>
<div className="container-fluid our-mission">
  
    <h2 className="heading-text">Restoration </h2>
    <div className="row">

        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 image-class"><Image src={img7} fluid thumbnail className="thumb-image"/></div>
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-justify"> Aside from restoring different property types, restoration companies will work across all verticals, from mould remediation to emergency flood repairs. A good restoration company won’t simply just decorate over damage, but instead they’ll put in remediation measures before restoring the property.
Here at Restorations, we cover a range of disaster recovery options, including:
    • Transmission Line Restoration
    • Fire Restoration
    • Flood Restoration
    • Sewage Clean-Up
    • Mould Remediation
    • Odour Removal
    • Specialist Drying
    • Building Repairs
    • Leak Detection
    • Building Surveys
</div>
</div>

</div>
<div className="container-fluid">
    <h2 className="heading-text"> Operation & Maintenance (O&M)</h2>
    <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-justify"><p className=""> Our team shall endeavour to achieve 100% availability during the operation and maintenance of the transmission lines. The following types of breakdowns occur on any transmission line:
    • Tower collapse including foundation failure
    • Cross arms failure of tower
    • Earth wire failure
    • Jumper failure
    • Conductor snapping and breakages
    • Insulator failure
    • Reduction in clearances due to swing/ falling and growth of tree and branches
    • Hardware failure
</p></div>
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 image-class"><Image src={img8} fluid thumbnail className="thumb-image"/></div>
    </div>
</div>
<div className="container-fluid our-mission">
    
    <h2 className="heading-text">Manpower Outsourcing  </h2>
    <div className="row">

        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 image-class"><Image src={img9} fluid thumbnail className="thumb-image"/></div>
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-justify"> The major advantages of manpower staffing and outsourcing are:
    • Reduction in the employment expenses.
    • Minimization of long-term liabilities.
    • Retaining the head count.
    • Meeting the requirements of seasonal increase in the business.
The services that can be obtained through companies offering outsourcing of manpower include:
    • Transferring of ad hoc employees.
    • Transferring of contractual employees.
    • Project based recruitment.
    • In house/on site support of contractual employees.
The “LEVINA” also provide staffing solutions to the clients. We maintain a database of the most suitable candidates and are capable of recommending the best ones. The companies through their skill and trained workforce can also undertake the screening and interviews of the candidates and thus provide the ultimate staffing solution at a fraction of the cost that the company would be otherwise bearing.
</div>
</div>

</div>

<Footer />
   </div>
 );
 
}

export default Solution;